import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { config } from './config/app';
import { AppLoader } from './shared/app-loader/app-loader.component';
import { Store } from './config/store';
import { Title } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppLoader],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'Welcome';
  titleService = inject(Title);
  appTitle = environment.TITLE;
  favIconUrl = environment.FAVICON_URL;
  constructor(protected store: Store) {
    console.log('AppComponent constructor', config.env);
    this.titleService.setTitle(this.appTitle);
    this.setFavicon(this.favIconUrl);
  }

  setFavicon(faviconUrl: string) {
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }
}
